import { VehicleArea, VehiclePartTypeDto, VehicleProjection } from "@/core/api/generated/v1";

export class VehiclePartTypeHelper {
  public static hasArea(entity: VehiclePartTypeDto, area: Nil<VehicleArea>): boolean {
    return !!area && !!entity.areas && entity.areas.includes(area);
  }

  public static hasProjection(
    entity: VehiclePartTypeDto,
    projection: Nil<VehicleProjection>,
  ): boolean {
    return !!projection && !!entity.projections && entity.projections.includes(projection);
  }

  public static hasAreaProjection(
    entity: VehiclePartTypeDto,
    area: Nil<VehicleArea>,
    projection: Nil<VehicleProjection>,
  ): boolean {
    return (
      !!area &&
      !!projection &&
      !!entity.projectionsPerArea &&
      !!entity.projectionsPerArea[area]?.includes(projection)
    );
  }
}
